import { useIntl } from "react-intl";
import { SimpleFormCheck } from "src/app/components/form/SimpleFormCheck";
import reason from "src/app/utils/RateReasons/RateReasons.json";

const RateResonFormContainer = () => {
    const { formatMessage } = useIntl();
    return (
        <>
            <div className="mt-2">
                <label className="form-label font-weight-bold">
                    {formatMessage({ id: `common.field.reasonGroup1` })}
                </label>
                {reason.reasonGroup1.reasons.map((el, index) => (
                    <SimpleFormCheck
                        name={`reason.reasonGroup1.${el.value}`}
                        key={index}
                        label={formatMessage({ id: `common.field.${el.value}` })}
                    />
                ))}
            </div>
            <div className=" mt-2">
                <label className="form-label font-weight-bold">
                    {formatMessage({ id: `common.field.reasonGroup2` })}
                </label>
                {reason.reasonGroup2.reasons.map((el, index) => (
                    <SimpleFormCheck
                        name={`reason.reasonGroup2.${el.value}`}
                        key={index}
                        label={formatMessage({ id: `common.field.${el.value}` })}
                    />
                ))}
                {reason.reasonGroup3.reasons.map((el, index) => (
                    <SimpleFormCheck
                        name={`reason.reasonGroup3.${el.value}`}
                        key={index}
                        label={formatMessage({ id: `common.field.${el.value}` })}
                    />
                ))}
            </div>
        </>
    );
};

export default RateResonFormContainer;
